export const setupWizard = {
  top: {
    title: "Asistente de configuración",
    subtitleFallback: "Configuración básica del anuncio",
    stepCount: "Paso {current} de {total}",
    closeAria: "Cerrar asistente",
    closeTitle: "Cerrar",
  },
  intro: {
    title: "¡Vamos a preparar tu alojamiento juntos!",
    subBefore: "Te acompañamos paso a paso para dejar",
    yourListingFallback: "tu anuncio",
    subAfter: "listo para recibir huéspedes. No necesitas saber de tecnología: en unos minutos lo tendrás todo. 😊",
    start: "¡Empezar!",
    skip: "Ahora no, lo hago más tarde",
  },
  steps: {
    confirmation: {
      label: "Confirmación de reserva",
      desc: "Avisamos al huésped de que su reserva está confirmada por WhatsApp y por Email. Al desactivar esta opción no se le notificará. Si reserva por una OTA, será la OTA quien le notifique.",
    },
    welcome: {
      label: "Mensaje de bienvenida",
      desc: "El mensaje que recibe el huésped justo después de completar su registro (check-in online), con la bienvenida y las indicaciones de llegada.",
    },
    schedule: {
      label: "Programación de check-in",
      desc: "¿Cuándo quieres que le enviemos al huésped el enlace para hacer el check-in?",
    },
    hours: {
      label: "Hora de llegada y salida",
      desc: "¿A qué hora puede entrar y salir el huésped?",
    },
    locks: {
      label: "Tipo de cerradura",
      desc: "¿Cómo entra el huésped a tu alojamiento?",
    },
    authorities: {
      label: "Conexión a Autoridades",
      desc: "Enviamos el parte de viajeros a las autoridades por ti, sin que tengas que hacer nada.",
    },
    services: {
      label: "Servicios",
      desc: "Configura los servicios y comodidades que ofrece tu alojamiento.",
    },
    policies: {
      label: "Políticas",
      desc: "Las normas y condiciones de tu alojamiento.",
    },
    calendar: {
      label: "Prepara tu calendario",
      desc: "Te enseñamos a dejar tu calendario listo para recibir reservas.",
    },
  },
  nav: {
    back: "Atrás",
    next: "Siguiente",
    finish: "Finalizar",
  },
  preview: {
    audienceOwner: "Lo que ves tú (anfitrión)",
    audienceGuest: "Lo que ve el huésped",
    accommodationFallback: "Alojamiento",
    online: "en línea",
    today: "Hoy",
    captionGuestWeb: "Vista previa · web del huésped",
  },
  schedule: {
    title: "¿Cuándo se inicia el check-in?",
    hint: "Programa cuándo el agente envía el link de check-in al huésped. Se aplica a nivel de anuncio.",
    caption: "Vista previa · secuencia de check-in",
  },
  // Mensajes de muestra del bot de WhatsApp: se muestran VERBATIM (bilingües
  // ES+EN) en todos los idiomas porque reproducen el mensaje real del producto.
  checkin: {
    propFallback: "tu alojamiento",
    greeting: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{name}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
    quote: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*. Estoy aquí para ayudarte con el proceso de che…",
    subCheckin: "Vamos a hacer el check-in · Let's check-in",
    ok: "Ok",
    chooseLang: "Elige tu idioma",
    langEs: "Español",
    langEn: "English",
    thanks: "*Gracias* 👋 Este es tu link para hacer el Check-In. 😎",
  },
  confirmation: {
    toggleLabel: "¿Quieres que se envíe al huésped la confirmación de reserva por WhatsApp?",
    toggleHint: "En cuanto se confirme una reserva, le llegará este mensaje con todos los datos de su estancia. Así sabe que todo está en orden. 😊",
    stateOn: "Sí, enviar",
    stateOff: "No enviar",
    mapAlt: "Ubicación del alojamiento",
    addressFallback: "Dirección del alojamiento",
    caption: "Vista previa · mensaje de confirmación",
    propFallback: "tu alojamiento",
    guestSample: "Laura García",
    body: "Hola *{guest}* 👋\n\nTu reserva en *{name}* está confirmada ✅\n\nCódigo de reserva: *6233Q1VC5*\nFechas: *05/06/2026* – *07/06/2026* 📅\n\nPor este WhatsApp podrás solicitar tu link para el check-in online y, además, recibir las indicaciones de llegada.\nSi necesitas ayuda antes o durante la estancia, escríbenos por aquí 💬",
    cta: "🇪🇸 Para continuar con el check-in, pulsa el botón *Ok* o escribe *Ok*.",
  },
  policies: {
    guestBubble: "Para seguir con el proceso debes aceptar nuestros términos y condiciones.",
    termsTitle: 'Reglamentos y Normas VIVIENDA CON FINES TURÍSTICOS "{name}"',
    termsBodyLabel: "I.– REGISTRO",
    termsBodyText: "Todo huésped, tanto el individual como el de grupo deberá de llenar una hoja de registro de manera individual o bien por cada habitación, misma que le será proporcionada a su llegada o vía Online.",
    accept: "Acepto los términos y condiciones",
  },
  guestPreview: {
    continue: "Continuar",
  },
  authorities: {
    ofTotal: "de {total}",
    heading: "Información requerida según el Real Decreto 933/2021 del Gobierno de España",
    intro: "Por el Real Decreto 933/2021, con entrada en vigor el 2 de diciembre de 2024, necesitamos recopilar los siguientes datos para cumplir con las normativas de seguridad.",
    countryLabel: "País de residencia",
    sampleCountry: "🇪🇸 España",
    cityLabel: "Ciudad de residencia",
    sampleCity: "Málaga",
    addressLabel: "Dirección de residencia",
    sampleAddress: "Calle Larios 77",
    postalLabel: "Código postal de residencia",
  },
  locks: {
    embedEmpty: "Añade primero una unidad al anuncio para configurar las cerraduras y el acceso.",
  },
  calendar: {
    iframeTitle: "Prepara tu calendario",
    videoSoon: "El vídeo estará disponible aquí muy pronto.",
    hint: "Pon el vídeo y sigue los pasos: en un momento tendrás tu calendario listo para recibir reservas. 🎬",
  },
};
